module.exports = __webpack_public_path__ + "img/icon-dispositivos.52f80997.svg";